import PropTypes from 'prop-types';
import {MenuItem, TextField, Input} from '@material-ui/core';
import {I18n, Translate} from 'react-redux-i18n';

const TRAD_ROOT = 'subscriptions.questions.nbOfClients';

const VALUES = [
  {key: 'twoClients', value: 'TWO_ClIENT'},
  {key: 'twentyClients', value: 'TWENTY_CLIENT'},
  {key: 'fiftyClients', value: 'FIFTY_CLIENT'},
  {key: 'moreThanFiftyClients', value: 'MORE_THAN_FIFTY'}
];

function NbOfClientsQuestion(props) {
  return (
    <div className='row align-items-center'>
      <div className='col-6 d-flex justify-content-end'>
        <strong><Translate value={`${TRAD_ROOT}.title`}/></strong>
      </div>
      <div className='col-2 pl-0 ml-4 inline-container'>
        <TextField
          select
          value={props.answer}
          onChange={e => props.setAnswer(e.target.value)}
          input={<Input
            name="nbOfClients"
            id="nbOfClients"
          />}
          placeholder={I18n.t(`${TRAD_ROOT}.response.info`)}
        >
          {VALUES.map(el => (
            <MenuItem
              key={`nbOfClients-menuItem-${el.key}`}
              value={el.value}
            >
              <Translate value={`${TRAD_ROOT}.response.${el.key}`}/>
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );
}

NbOfClientsQuestion.defaultProps = {
  answer: null
};

NbOfClientsQuestion.propTypes = {
  setAnswer: PropTypes.func.isRequired,
  answer: PropTypes.string
};
export default NbOfClientsQuestion;
